import React from 'react';
import {observer} from 'mobx-react';
import {InteractiveTable, DropdownFilter, EmployeeNameWithAvatar, Button} from 'components';
import {AccountSummariesState} from '../state';
import {withState, t} from 'shared/core';
import {types, endpoints, formatTimeOffAmount} from 'main/tools';
import {TimeOffAccountSummary} from 'main/stores/time_off';
import BalanceAdjustmentModal from './BalanceAdjustmentModal';

const AdjustmentButton = ({model, uiState}) => {
  if (!model.hasLink('adjustment') || model.unlimited) return null;

  return (
    <Button onClick={() => uiState.openBalanceAdjustmentModal(model)} className='Btn--icon' trait='default' hint={t('time_off.account_summaries.Adjust Balances')}>
      <i className='material-icons h2 waterloo'>{'exposure'}</i>
    </Button>
  );
};

const Amount = ({model, amount, uiState}) => {
  return formatTimeOffAmount(amount, uiState.typeById(model.typeId).unit);
};

const getColumns = (uiState) => {
  return [{
    header: 'time_off.account_summaries.Name',
    render: model => <EmployeeNameWithAvatar href={`/employees/${model.employee.id}/time-off`} employee={model.employee}/>,
    sortBy: 'name',
    width: 3
  },
  {
    header: 'time_off.account_summaries.Accrued',
    render: model => <Amount uiState={uiState} amount={model.accrued(uiState.typeById(model.typeId))} model={model} />,
    sortable: false,
    width: 2
  },
  {
    header: 'time_off.account_summaries.Available',
    render: model => <div className={`${model.available(uiState.typeById(model.typeId)) < 0 ? 'scarlet' : ''}`}><Amount uiState={uiState} amount={model.available(uiState.typeById(model.typeId))} model={model} /></div>,
    sortable: false,
    width: 2
  },
  {
    header: 'time_off.account_summaries.Used',
    render: model => <Amount uiState={uiState} amount={model.used(uiState.typeById(model.typeId))} model={model} />,
    sortable: false,
    width: 2
  },
  {
    header: 'time_off.account_summaries.Scheduled',
    render: model => <Amount uiState={uiState} amount={model.scheduled(uiState.typeById(model.typeId))} model={model} />,
    sortable: false,
    width: 2
  },
  {
    component: AdjustmentButton,
    width: 1
  }
];};

const LOCALIZATION = {
  emptyState: 'time_off.account_summaries.No employees to show'
};

const AccountSummariesWithStateContainer = observer(({uiState}) => {
  const {timeOffTypes} = uiState;

  return (
    <div className='Container'>
      <InteractiveTable
        uiState={uiState}
        columns={getColumns(uiState)}
        localization={LOCALIZATION}
        showLinks={false}
        sortable={true}
        saveStateToUrl
        onMount={agent => uiState.setInteractiveAgent(agent)}
        proxy={{
          type: 'async',
          modelType: types.TIME_OFF.ACCOUNT_SUMMARY,
          model: TimeOffAccountSummary,
          endpoint: endpoints.TIME_OFF.ACCOUNT_SUMMARIES
        }}>
        <DropdownFilter options={timeOffTypes} attr='type'/>
      </InteractiveTable>
      <BalanceAdjustmentModal uiState={uiState}/>
    </div>
  );
});

export default withState(AccountSummariesWithStateContainer, AccountSummariesState);
